module.exports = __webpack_public_path__ + "img/emptyListAvatar.9123da22.png";